export const statusColor: Record<string, string> = {
  imported: '#8c8c8c',
  queued: '#1677ff',
  processing: '#1677ff',
  waiting_for_review: '#fa8c16',
  needs_manual_review: '#fa541c',
  completed: '#52c41a',
  failed: '#ff4d4f',
  partial: '#13c2c2',
  succeeded: '#52c41a',
  cancelled: '#8c8c8c',
  interrupted: '#faad14',
  running: '#1677ff',
}

export const sourceStatusColor: Record<string, string> = {
  pending: '#8c8c8c',
  processing: '#1677ff',
  needs_review: '#fa8c16',
  saved: '#52c41a',
  failed: '#ff4d4f',
  missing: '#d9363e',
}

// Preset (named) Antd Tag colors render as a soft pastel chip (light fill +
// matching thin border) instead of a solid saturated block, which reads much
// calmer for a dense data table than passing raw hex values.
export const stageStatusColor: Record<string, string> = {
  waiting: 'default',
  queued: 'default',
  processing: 'blue',
  done: 'green',
  failed: 'red',
  upstream_missing: 'orange',
  not_applicable: 'default',
  // Template debug-pipeline stage states (see TemplateStageStatus).
  idle: 'default',
  stale: 'gold',
}

export function formatBytes(n?: number | null) {
  if (!n && n !== 0) return '-'
  if (n < 1024) return `${n} B`
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`
  return `${(n / 1024 / 1024).toFixed(1)} MB`
}
